import {LiveDashboard} from "@common/ui-components/live/live-dashboard/live-dashboard";
import collection from "./container-buttons-collection.json";
import data from "./container-buttons-data.json";

export const ContainerButtonsThemeAuto = (props) => {
    return LiveDashboard({
        collection,
        defaultData: data,
        disabledTileActions: true,
        ...props,
    });
};
